<template >
    <section class=" flex flex-col justify-center items-center bg-bgBanner">
       
        <section class="flex max-w-1440 flex-col lg:flex-row  py-36 xl:py-96 xl:px-41  ">
            <section class="flex justify-center">
                <img class="max-w-25" v-if="isMobile" src="../../../../v2/src/assets/images/logo.svg" alt="">

            </section>
            <section class="w-full flex items-center justify-center px-20 lg:px-0">
                <img src="../../../../v2/src/assets/images/secondaryBanner.webp" class="h-full w-full max-h-83.5 max-w-75  pt-6 md:pt-16 xl:pt-9 lg:pb-11" alt="">
            </section>

            <section class="flex flex-col px-6 md:px-0 text-left md:max-w-148 lg:ml-28 xl:ml-40 lg:max-w-109 xl:max-w-127 text-lg leading-22px" :class="{'text-center': isMobile}">
                <img class="max-w-25" v-if="!isMobile" src="../../../../v2/src/assets/images/logo.svg" alt="">
                <h1 class="text-3xl text-left lg:text-14 font-bold pt-8" :class="{'text-center': isMobile}"> Felicitaciones</h1>

                <p class="pt-8 leading-9">Tu camino para ser un experto en <span class="font-bold">TELEMEDICINA</span> empieza aquí</p>
                <p class="pt-4 ">Celebro de todo corazón tu decisión de pasar su profesión al siguiente nivel, y así servir más y mejor a los pacientes. Ingresa a tu buzón de correos donde te he enviado un un email para que puedas descargar  LOS 10 OBSTÁCULOS MÁS FRECUENTES DE LOS PROFESIONALES DE LA SALUD AL MOMENTO DE INICIAR CON TELEMEDICINA Esperamos la disfrutes!</p>
                
                <section @click="toBack" class="flex flex-row justify-center lg:justify-start  pt-11 ">
                    <img src="../../../../v2/src/assets/images/icons/arrow.svg" class=" cursor-pointer rotate-180 transform mr-2.5" alt="">
                    <p class="text-redd cursor-pointer ">Regresar</p>

                </section>
            </section>
        </section>
       
    </section>
</template>
<script>
import utilsMixin from "../../../../v2/src/mixins/utilsMixin"
export default {
    mixins: [utilsMixin],
    components :{
   },
    mounted(){
            if(localStorage.getItem("firstName") == null || localStorage.getItem("lastName") == null || localStorage.getItem("email") == null){
                this.$router.push({name: "10-obstaculos"})
            }
    },
    
    methods: {
       toBack(){
        this.$router.push({
          name: "10-obstaculos"
        })
       }
   },
}
</script>